import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { HistorialDescargablesI } from '../../../models/descargables'
import { useState } from 'react'
import { useUserBarrilitoContext } from '../../../context/UsersBarrilitoContext'
import useFetchDescargables from '../../../hooks/useFetchDescargables'
import useFetchUsersBarrilito from '../../../hooks/useFetchUsersBarrilito'
import { formatDateHourMinute, getUserName } from '../../../utils/strings'
import { useDescargablesContext } from '../../../context/DescargablesContext'
import UIButton from '../../UI/UIButton'
import {  getHistorialDescargableAll } from '../../../services/descargables/historialDescargable'

const BtnExportHistorial = () => {

    const [loading, setLoading] = useState(false)
    const { usersBarrilito } = useUserBarrilitoContext()
    useFetchDescargables()
    useFetchUsersBarrilito()
    const { descargables } = useDescargablesContext()

    const exportToExcel = async () => {
      setLoading(true)

      const historialDescargableDB = await getHistorialDescargableAll() as HistorialDescargablesI

      let data = (historialDescargableDB || []).map((row) => {
        const [fecha, hora] = formatDateHourMinute(row.fecha_descarga)?.split(' ') || ['', '']
        return {
          ID: row.id,
          Descargable: descargables.find((descargable) => descargable.id === row.id_descargable)?.titulo || '',
          Usuario: getUserName(usersBarrilito.find((user) => user.id === row.id_usuario)),
          Fecha: fecha,
          Hora: hora,
        }
      })

      // Rellenar diferencia por descargable
      descargables.forEach((descargable) => {
        const descargasReales = (historialDescargableDB || []).filter(h => h.id_descargable === descargable.id).length
        const totalDescargas = (descargable as any)?.descargados || 0
        const filasARellenar = Math.max(0, totalDescargas - descargasReales)

        const fechaFicticia = '2026-02-20'
        const horaFicticia = '12:00'
        for (let i = 0; i < filasARellenar; i++) {
          data.push({
            ID: '0',
            Descargable: descargable.titulo || '',
            Usuario: 'sin dato',
            Fecha: fechaFicticia,
            Hora: horaFicticia,
          })
        }
      })

      const worksheet = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Historial descargas')
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
      const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' })
      const fileName = `historial_descarga.xlsx`
      saveAs(dataBlob, fileName)

      setLoading(false)
    }

  return (
    <UIButton onClick={exportToExcel} text="Descargar historial" loading={loading} />
  )
}

export default BtnExportHistorial